import React from 'react'

const Australia = () => {
  return (
    <div>Australia</div>
  )
}

export default Australia